import React, { Component } from 'react';

class Filters extends Component {
    render() {
        return (
            <div className="form-elements" style={{ fontFamily: "var(--font-titles)" }}>
                <h3 style={{
                    color: 'var(--secondary-foreground, #000)',
                    fontWeight: '700',
                    marginBottom: '10px',
                    fontFamily: 'var(--font-titles)'
                }}>
                    Filters
                </h3>
                <div style={{ display: 'flex', flexDirection: 'row', gap: 'calc(var(--spacing, 16px) * 6)', alignItems: 'center' }}>
                    <div
                        className="filter-sort-button interactive-element-hover"
                        style={{
                            display: 'flex',
                            gap: 'calc(var(--spacing, 16px) * 3)',
                            padding: 'calc(var(--spacing, 16px) * 3) calc(var(--spacing, 16px) * 6)',
                            color: 'var(--secondary-foreground, #000)',
                            backgroundColor: 'var(--secondary, #F6F6F7)',
                            borderRadius: 'var(--radius, 10px)',
                            boxShadow: 'var(--shadow)',
                            cursor: 'pointer'
                        }}>
                        <div className='spark-icon-sliders' style={{
                            fontSize: '20px',
                            color: 'var(--secondary-foreground, #000)',
                            alignSelf: 'center',
                        }}>
                        </div>
                        <div
                            type="text"
                            className="spark-text-input"
                            style={{
                                fontSize: '16px',
                                fontFamily: "var(--font-body)",
                            }}>
                            Filter & sort (2)
                        </div>
                    </div>
                    <div className='filter-sort-button interactive-element-hover'
                        style={{
                        padding: 'calc(var(--spacing, 16px) * 3) calc(var(--spacing, 16px) * 6)',
                        backgroundColor: 'var(--secondary, #F6F6F7)',
                        borderRadius: 'var(--radius, 10px)',
                        display: 'flex',
                        gap: 'calc(var(--spacing, 16px) * 3)',
                        boxShadow: 'var(--shadow)'

                    }}>
                        <label htmlFor="filter1" style={{
                            color: 'var(--secondary-foreground, #000)',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontFamily: "var(--font-body)",
                            fontSize: '16px',
                            fontWeight: '400',
                        }}>
                            <input
                                type="checkbox"
                                id="filter1"
                                defaultChecked
                                tabIndex="0"
                                className="focusable-input"
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    marginRight: '8px',
                                    accentColor: 'var(--primary, #309AB5)',
                                    borderRadius: 'var(--radius, 10px)',
                                    cursor: 'pointer'
                                }}
                            />
                            Filter 1
                        </label>
                        <label htmlFor="filter2" style={{
                            color: 'var(--secondary-foreground, #000)',
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontFamily: "var(--font-body)",
                            fontSize: '16px',
                            fontWeight: '400',
                        }}>
                            <input
                                type="checkbox"
                                id="filter2"
                                tabIndex="0"
                                className="focusable-input"
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    marginRight: '8px',
                                    accentColor: 'var(--primary, #309AB5)',
                                    borderRadius: 'var(--radius, 10px)',
                                    cursor: 'pointer'
                                }}
                            />
                            Filter 2
                        </label>
                    </div>
                    <div className="row ml-0"
                        style={{
                            padding: 'calc(var(--spacing, 16px) * 3) calc(var(--spacing, 16px) * 6)', alignItems: 'center', backgroundColor: 'var(--secondary, #F6F6F7)',
                            borderRadius: 'var(--radius, 10px)',
                            gap: 'calc(var(--spacing, 16px) * 1.5)',
                            boxShadow: 'var(--shadow)'

                        }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: 'var(--primary, #309AB5)',
                            color: 'var(--primary-foreground, #F6F6F7)',
                            padding: 'calc(var(--spacing, 16px) / 2) calc(var(--spacing, 16px) * 2)',
                            borderRadius: 'var(--radius, 10px)',
                            fontSize: '14px',
                            fontFamily: "var(--font-body)",
                            fontWeight: '600',
                            marginRight: '16px'
                        }}>
                            <span style={{ marginLeft: 'calc(var(--spacing, 16px) / 2)' }}>
                                Selected filter
                            </span>
                            <span className="filter-chip-close-button focusable-element" tabIndex="0" style={{
                                marginLeft: 'calc(var(--spacing, 16px) * 2)',
                                cursor: 'pointer',
                                fontSize: '20px',
                                padding: '2px 5px',
                                lineHeight: '16px'
                            }}>
                                ×
                            </span>
                        </div>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: 'var(--primary, #309AB5)',
                            color: 'var(--primary-foreground, #F6F6F7)',
                            padding: 'calc(var(--spacing, 16px) / 2) calc(var(--spacing, 16px) * 2)',
                            borderRadius: 'var(--radius, 10px)',
                            fontSize: '14px',
                            fontFamily: "var(--font-body)",
                            fontWeight: '600',
                            marginRight: '16px'
                        }}>
                            <span style={{ marginLeft: 'calc(var(--spacing, 16px) / 2)' }}>
                                Selected filter
                            </span>
                            <span className="filter-chip-close-button focusable-element" tabIndex="0" style={{
                                marginLeft: 'calc(var(--spacing, 16px) * 2)',
                                cursor: 'pointer',
                                fontSize: '20px',
                                padding: '2px 5px',
                                lineHeight: '16px'
                            }}>
                                ×
                            </span>
                        </div>
                        <span className="in-context-link-hover focusable-element" tabIndex="0" style={{
                            color: 'var(--primary, #309AB5)',
                            fontSize: '14px',
                            fontWeight: '500',
                            fontFamily: "var(--font-body)",
                            cursor: 'pointer',
                        }}>
                            Clear all
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/Filters.js